import { cloneDeep } from 'lodash'

export function getNormalizedStructure(struct) {
    const _tmpStructure = cloneDeep(struct)

    // cover
    _tmpStructure.cover.header = _tmpStructure.cover.header.trim()
    _tmpStructure.cover.description = _tmpStructure.cover.description.trim()
    _tmpStructure.cover.buttonText = _tmpStructure.cover.buttonText.trim()
    _tmpStructure.cover.image = _tmpStructure.cover.image ? _tmpStructure.cover.image.trim() : null
    _tmpStructure.cover.imageDisclaimer = _tmpStructure.cover.imageDisclaimer.trim()
    // questions
    _tmpStructure.questions = _tmpStructure.questions.map(qEl => {
        return {
            ...qEl,
            text: qEl.text.trim(),
            image: qEl.image ? qEl.image.trim() : null,
            imageDisclaimer: qEl.imageDisclaimer.trim(),
            answers: qEl.answers.map(aEl => {
                return {
                    ...aEl,
                    text: aEl.text.trim(),
                    description: aEl.description.trim(),
                }
            }),
        }
    })
    // results
    _tmpStructure.results = _tmpStructure.results.map(elR => {
        return {
            ...elR,
            header: elR.header.trim(),
            description: elR.description.trim(),
            image: elR.image ? elR.image.trim() : null,
            imageDisclaimer: elR.imageDisclaimer.trim(),
        }
    })

    return _tmpStructure
}

export const hasError = (errors, target) => errors.indexOf(target) !== -1

export const checkAndReturnArrayOfErrors = (errors, target, text) => {
    if (hasError(errors, target)) return [text]
    return []
}
